<template>
	<div class="space-y-8">
        <button type="button"
                role="radio"
                class="shadow sm:rounded-lg mb-6 block w-full text-left border-2 border-gray-50 transition-colors duration-200 focus:outline-none"
                :class="{ 'bg-gray-50': option.value !== value, 'border-primary-600 bg-white': option.value === value }"
                v-for="option in options"
                @click="$emit('input', option.value)"
        >
            <div class="px-4 py-5 sm:p-6 flex justify-between items-center">
                <div>
                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                        {{ option.name }}
                    </h3>
                    <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
                        <p>
                            {{ option.description }}
                        </p>
                    </div>
                </div>

                <div class="w-8 h-8 rounded-full flex justify-center items-center transition-colors duration-200"
                     :class="{ 'bg-gray-50 text-gray-50': option.value !== value, 'bg-primary-200 text-primary-600': option.value === value }"
                >
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                </div>
            </div>
        </button>
    </div>
</template>

<script>
    export default {
        data() {
		    return {
		        options: [
                    {
                        name: 'Credit / Debit Card',
                        description: 'Pay by card',
                        value: 'card',
                    },
                    // {
                    //     name: 'BACS',
                    //     description: 'Pay by BACS (free bank to bank account transfer)',
                    //     value: 'bacs',
                    // },
                    // {
                    //     name: 'Pingit / Paym',
                    //     description: 'Pay by Pingit/Paym (free of charge)',
                    //     value: 'pingitPaym',
                    // },
                ]
            }
        },

        props: {
            value: {
                type: String,
            }
        }
	}
</script>
